import { BitkitButton, IconErrorCircle } from '@bitrise/bitkit-v2';
import { Text } from '@chakra-ui/react/text';
import { ReactNode } from 'react';

import BuildListSkeletonOverlayContent from '../../../components/BuildListItem/BuildListSkeletonOverlayContent';

type BuildListLoadingErrorContentProps = { message: ReactNode; retry: VoidFunction };
const BuildListLoadingErrorContent = ({ message, retry }: BuildListLoadingErrorContentProps) => (
  <BuildListSkeletonOverlayContent color="color/red/strong">
    <IconErrorCircle boxSize="40" />
    <Text textStyle="heading/h2">{message}</Text>
    <BitkitButton variant="tertiary" onClick={() => retry && retry()}>
      Retry
    </BitkitButton>
  </BuildListSkeletonOverlayContent>
);

export default BuildListLoadingErrorContent;
